import InputForm from '../InputForm';


function show(country) {
    switch (country) {
        case "br":
            return (
                <div className="content content-ted">
                    <div className="col-content">
                        <InputForm
                            for={"favorecido"}
                            label={"FAVORECIDO"}
                            data_lang_label={"favorecid_"}
                            data_bank_str={"accoauntable"}
                        />
                        <InputForm
                            for={"cnpj"}
                            label={"CNPJ"}
                            data_lang_label={"cnpj"}
                            data_bank_str={"document"}
                        />
                        <InputForm
                            for={"nomebanco"}
                            label={"NOME DO BANCO"}
                            data_lang_label={"nome_banck"}
                            data_bank_str={"bank_name"}
                        />
                    </div>
                    <div className="col-content">
                        <InputForm
                            for={"nconta"}
                            label={"NÚMERO DA CONTA"}
                            data_lang_label={"nu_conta"}
                            data_bank_str={"account"}
                        />
                        <InputForm
                            for={"agencia"}
                            label={"AGÊNCIA"}
                            data_lang_label={`agenc_banck_BRASIL`}
                            data_bank_str={"agency"}
                        />
                        <InputForm
                            for={"tpconta"}
                            label={"TIPO DA CONTA"}
                            data_lang_label={"tp_conta"}
                            data_bank_str={"account_type"}
                        />
                    </div>
                </div>
            )
        case "co":
            return (
                <div className="content content-ted">
                    <div className="col-content">
                        <InputForm
                            for={"favorecido"}
                            label={"FAVORECIDO"}
                            data_lang_label={"favorecid_"}
                            data_bank_str={"favored_fastcoin"}
                        />
                        <InputForm
                            for={"nit"}
                            label={"NIT"}
                            data_lang_label={"agenc_banck_COLOMBIA"}
                            data_bank_str={"ident_NIT"}
                        />
                    </div>
                    <div className="col-content">
                        <InputForm
                            for={"nomebanco"}
                            label={"NOME DO BANCO"}
                            data_lang_label={"nome_banck"}
                            data_bank_str={"name_bank"}
                        />
                        <InputForm
                            for={"nconta"}
                            label={"NÚMERO DA CONTA"}
                            data_lang_label={"nu_conta"}
                            data_bank_str={"account_bank"}
                        />
                    </div>
                </div>
            )
        default:
            return (
                <div className="content content-ted">
                    <div className="col-content">
                        <InputForm
                            for={"favorecido"}
                            label={"FAVORECIDO"}
                            data_lang_label={"favorecid_"}
                            data_bank_str={"favored_fastcoin"}
                        />
                        <InputForm
                            for={"cnpj"}
                            label={"CNPJ"}
                            data_lang_label={"cnpj"}
                            data_bank_str={"cnpj_fastcoin"}
                        />
                        <InputForm
                            for={"nomebanco"}
                            label={"NOME DO BANCO"}
                            data_lang_label={"nome_banck"}
                            data_bank_str={"name_bank"}
                        />
                    </div>
                    <div className="col-content">
                        <InputForm
                            for={"nconta"}
                            label={"NÚMERO DA CONTA"}
                            data_lang_label={"nu_conta"}
                            data_bank_str={"account_bank"}
                        />
                        <InputForm
                            for={"agencia"}
                            label={"AGÊNCIA"}
                            data_lang_label={`agenc_banck_BRASIL`}
                            data_bank_str={"agency_bank"}
                        />
                        <InputForm
                            for={"tpconta"}
                            label={"TIPO DA CONTA"}
                            data_lang_label={"tp_conta"}
                            data_bank_str={"type_account"}
                        />
                    </div>
                </div>
            )
    }
}

export default function ShowFieldGroup(props) {
    return show(props.country);
}